import { useEffect, useState } from "react";
import { setUserAuthenticated } from "../../redux/userIsAuthenticatedReducer";
import { loginMicroSoftUser, loginUser } from "../../api/loginApi";
import { tokenKey, refreshTokenKey, expirationKey } from "../../api/OAuth";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Spin } from "antd";
import { AppRoutes } from "../../AppRoutes";
import { useLocation } from "react-router-dom";
import LoginFail from "./LoginFail";
import { config } from "../../config";
import { saveUserProfileFromToken } from "../../utils/userProfileUtils";

export default function MicrosoftLoginCallback() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const location = useLocation();
    const { adentis, agap2, bee, codewin, teamit, recodme, kcsit, loginPage } = config;

  useEffect(() => {
    const handleLogin = () => {
      const code = new URLSearchParams(location.search).get("code");
      const errorDescription = new URLSearchParams(location.search).get(
        "error_description"
      );

      if (code) {
        //debugger;
        let companyId = "";
        if (window.location.host === adentis.host) {
          companyId = adentis.companyId;
        } else if (window.location.host === agap2.host) {
            companyId = agap2.companyId;
        } else if (window.location.host === bee.host) {
          companyId = bee.companyId;
        } else if (window.location.host === codewin.host) {
            companyId = codewin.companyId;
        } else if (window.location.host === teamit.host) {
            companyId = teamit.companyId;
        } else if (window.location.host === recodme.host) {
            companyId = recodme.companyId;
        } else if (window.location.host === kcsit.host) {
            companyId = kcsit.companyId;
        }
        loginMicroSoftUser({ authorizationCode: code, companyId: companyId })
          .then((response) => {
            localStorage.setItem(tokenKey, response.data.token);
            localStorage.setItem(refreshTokenKey, response.data.refreshToken);
            localStorage.setItem(expirationKey, response.data.expiration);
            saveUserProfileFromToken(response.data.token);
            dispatch(setUserAuthenticated());

            navigate(AppRoutes.home.path);
          })
          .catch((error) => {
            LoginFail(
              () => navigate(AppRoutes.login.path),
              "There was an error with your login. Please contact the support team for assistance."
            );
          });
      } else if (errorDescription) {
        LoginFail(
          () => navigate(AppRoutes.login.path),
          errorDescription + ". Please contact the support team for assistance."
        );
      } else {
        LoginFail(
          () => navigate(AppRoutes.login.path),
          "There was an error with your login. Please contact the support team for assistance."
        );
      }
    };

    handleLogin();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div>
        <Spin size="large">
          <h1>Processing login</h1>{" "}
        </Spin>
      </div>
    </div>
  );
}
